export const ABSTRACT_SERVICE = 'ABSTRACT_SERVICE'
export const SCHEDULED_SERVICE = 'SCHEDULED_SERVICE'
export const SINGLE_EVENT = 'SINGLE_EVENT'
export const SCHEDULED_EVENT = 'SCHEDULED_EVENT'
